<!-- <app-header *ngIf="loggedIn"></app-header>
<app-sidebar></app-sidebar> -->
<style>
  @import url('https://fonts.googleapis.com/css2?family=League+Gothic&display=swap');
</style>
<div *ngIf="loading" class="fullScreenLoading"></div>

<div id="nav_bar" class="topnav" *ngIf="loggedIn">
  <div style="display: flex;
  width: 100%;
  padding-left: calc(75px + 1rem);
  justify-content: space-between;
  align-items: center;">
    <p  class="label-grey" style="
      font-size: large;
    color: #666;
    font-weight: 400;
    margin: 0 !important;">{{actualPageName}}</p>
    <div style="display: flex;
    gap: 1rem;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: -5px;">
      <!-- <p-button 
      icon="pi pi-question" 
      label="Informar problema"
      severity="warning" 
      variant="text"
      [text]="true"
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/>
      <p-button 
      icon="pi pi-question" 
      [rounded]="true" 
      severity="warning" 
      [outlined]="true" 
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      [raised]="true"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/> -->
      <!-- <p-button 
      icon="pi pi-question" 
      [rounded]="true" 
      severity="warning" 
      [outlined]="true" 
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/> -->
      <p-button 
      icon="pi pi-exclamation-triangle" 
      label="Informar problema"
      severity="warning" 
      variant="text"
      [text]="true"
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/>
      <!-- <p-button 
      icon="pi pi-exclamation-triangle" 
      [rounded]="true" 
      severity="warning" 
      [outlined]="true" 
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      [raised]="true"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/>
      <p-button 
      icon="pi pi-exclamation-triangle" 
      [rounded]="true" 
      severity="warning" 
      [outlined]="true" 
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      (click)="showErrorReportModal()"
      aria-label="Reportar error"/> -->

      <!-- <button"success" | "info" | "warning" | "danger" | "help" | "primary" | "secondary" | "contrast"'
      *ngIf="loggedIn && me"
      class="report-error-navbar"
      (click)="showErrorReportModal()"
      aria-label="Reportar error">
        <i class="pi pi-exclamation-triangle"></i>
      </button> -->
      <!-- <p-dropdown
      [options]="countries"
      [(ngModel)]="selectedCountry"
      optionLabel="name"
      filterBy="name"
      placeholder="Select a Country" 
      (onChange)="changeLanguage($event)"
      styleClass="w-20rem">
        <ng-template pTemplate="selectedItem" let-selectedOption>
            <div style="display: flex; gap: 0.5rem; align-items: center;">
                <img 
                    src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                    [class]="'flag flag-' + selectedCountry.code.toLowerCase()"
                    style="width: 18px" />
                <div>{{ selectedOption.code.toUpperCase() }}</div>
            </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
            <div style="display: flex; gap: 0.5rem; align-items: center;">
                <img 
                    src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                    [class]="'flag flag-' + country.code.toLowerCase()" 
                    style="width: 18px" />
                <div>{{ country.name }}</div>
            </div>
        </ng-template>
      </p-dropdown>
      <a href=""><i class="pi pi-bell mr-4 p-text-secondary" pBadge style="font-size: 1.5rem" ></i></a>
      <div class="header-img-container" (click)="op.toggle($event)">
        <img height="100%" width="auto" src="assets/user_logo.png" alt="">
      </div>
      <p-overlayPanel #op>
        <div style="margin-top: 2.2rem;">
          <a (click)="logout()" routerLink="login" class="menu-button expansion-panel-font hover-class" style="padding-left: 0; width: 100%;">
            <button mat-button class="sidebar-client-button" style="margin-left: -4px !important;">
              <i class="pi pi-sign-out sidebar-section-icon" style="padding: 15px;"></i>
              <span class="sidebar-section-text" style="padding: 0px !important; font-weight: 400 !important;">Cerrar sesión</span>  
            </button>
          </a>
        </div>
      </p-overlayPanel> -->
    </div>
  </div>
</div>
<div style="display: flex; position: relative;" class="body" *ngIf="!loading">
  <div class="app-blur" *ngIf="sidebarVisible"></div>
  <div class="layout-sidebar" 
  [@sidebarAnimation]="!sidebarVisible ? 'closed' : 'open'"
  (mouseenter)="sidebarVisible = true"
  (mouseleave)="sidebarVisible = false"
  *ngIf="loggedIn">
  
    <div class="sidebar-header">
      <div style="width: 75px; height: 45px; display: flex; justify-content: center;">
        <img style="height: 100%; width: auto;" src="assets/logos/logo-reducido-imadata.png" alt="Logo">
      </div>
      <div>
        <!-- <div style="position: absolute; top: 10px; left: 70px; height: 30px;  margin-left: 10px;">
          <img style="width: auto; height: 100%;" src="assets/logos/Logo_IMADATA_Letras_4.png" alt="">
        </div> -->
        <div class="sidebar-header-text-Logo">
          <p><span style="color: black;">IMA</span><span style="color: green;">DATA</span></p>
        </div>
      </div>
    </div>
    <div class="sidebar-user-section">
        <p class="sidebar-header-username">{{dict['welcome'](me?.first_name ? me.first_name : '')[this.currentLanguage]}}</p>
    </div>
    <div class="layout-menu-container">
      
      <p-scroller [items]="clientSections" [itemSize]="50" scrollHeight="100%" styleClass="border-1 surface-border" 
      [style]="{'width': '100%','height': 'calc(100% - 120px)'}" *ngIf="!multiplesCompanies">
        <ng-template pTemplate="section" let-section let-options="options">
          <a mat-list-item [routerLink]="section.url" style="padding-left: 5px;" class="hover-class">
            <button mat-button class="sidebar-client-button">
              <i [class]="section.icon+' sidebar-section-icon'" style="padding: 20px;"></i>
              <span *ngIf="sidebarVisible" class="sidebar-section-text" style="padding: 0px !important; font-weight: 400 !important;"
                [style.color]="section.active ? 'rgb(8, 156, 32)' : ''">{{section.nombre}}</span>
            </button>
          </a>
        </ng-template>
      </p-scroller>

      <p-scroller [items]="companies" [itemSize]="50" scrollHeight="100%" styleClass="border-1 surface-border" 
      [style]="{'max-width': '100%','height': '100%'}" *ngIf="multiplesCompanies">
        <ng-template pTemplate="company" let-company let-options="options" style="overflow-x: hidden;">
          <mat-expansion-panel class="expansion-panel" [expanded]="false">
            <mat-expansion-panel-header 
            style="min-width: 120px;"
            [style.height]="sidebarVisible ? '3rem !important' : '3rem !important'">
              <mat-panel-title style="display: flex;">
                <i class="pi pi-circle" 
                style="font-weight: 700;
                color: rgb(8 156 32);
                font-size: x-small;
                margin: 0px 35px 0px 5px;"
                [style.margin]=" sidebarVisible ? '0px 0px 0px 5px' : '0px 35px 0px 5px'"></i>
                <span [style.opacity]="sidebarVisible ? 1 : 0"
                class="sidebar-title-company sidebar-section-text">
                  {{company.name}}
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
      
            <mat-nav-list *ngFor="let page of company.pages" style="padding-left: 0; min-width: 150px; overflow: hidden;">
              <a [routerLink]="page.url" style="padding-left: 0;" class="hover-class">
                <button mat-button class="sidebar-client-button" style="margin-left: -4px !important;">
                  <i [class]="page.icon+' sidebar-section-icon'" style="padding: 15px;"></i>
                  <span *ngIf="sidebarVisible" class="sidebar-section-text" style="padding: 0px !important; font-weight: 400 !important;"
                  [style.color]="page.active ? 'rgb(8, 156, 32)' : ''">{{page.nombre}}</span>  
                </button>
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
        </ng-template>
      </p-scroller>
    </div>
    <div class="sidebar-logout">
      <mat-divider class="my-divider"></mat-divider>
      <a (click)="logout()" routerLink="login" class="menu-button expansion-panel-font hover-class"
      *ngIf="sidebarVisible" [@desvanecer]="!sidebarVisible ? 'closed' : 'open'" style="padding-left: 0; width: 100%;">
        <button mat-button class="sidebar-client-button" style="margin-left: -4px !important;">
          <i class="pi pi-sign-out sidebar-section-icon" style="padding: 15px;"></i>
          <span *ngIf="sidebarVisible" class="sidebar-section-text" style="padding: 0px !important; font-weight: 400 !important;">{{dict['sign_out']()[this.currentLanguage]}}</span>  
        </button>
        
      </a>
    </div>
  </div>
  <div [class]="loggedIn ? 'app-contain' : 'app-contain-login'" >
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>


<!-- <button
  *ngIf="loggedIn && me"
  class="report-error-fab"
  (click)="showErrorReportModal()"
  aria-label="Reportar error"
>
  <i class="pi pi-exclamation-triangle"></i>
</button> -->

<!-- Modal de reporte de error -->
<p-dialog
  header="Reportar error"
  [(visible)]="errorReportModalVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ 'min-width': '50vw', 'max-width': '80vw' }"
  [baseZIndex]="2000001"
>
  <form (ngSubmit)="submitErrorReport()" #errorForm="ngForm">
    <div class="p-field">
      <label 
      for="errorDescription"
      class="bug-report-label-field"
      >Describe el error:</label>
      <textarea
        id="errorDescription"
        name="errorDescription"
        [(ngModel)]="bugReportPayload.description"
        rows="5"
        required
        class="bug-report-description-textarea"
        placeholder="Describe el problema que encontraste..."
      ></textarea>
      <!-- ingresar fotos captura de pantalla -->
      <label 
      for="fileInput" 
      class="bug-report-label-field"
      >Adjuntar captura de pantalla (opcional):</label>
      <p-fileUpload
        [multiple]="true"
        accept="image/*"
        maxFileSize="1000000"
        mode="advanced"
        [showUploadButton]="false"
        [showCancelButton]="false"
        chooseLabel="Cargar imagen"
        (onSelect)="onFileSelected($event)">
        <ng-template #empty>
          <div>Arrastra y suelta imágenes aquí para subir.</div>
        </ng-template>
      </p-fileUpload>

    </div>
    <div class="p-dialog-footer" style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 1rem;">
      <button pButton type="button" label="Cancelar" (click)="errorReportModalVisible=false"></button>
      <button pButton type="submit" label="Enviar" [disabled]="!bugReportPayload.description"></button>
      <!-- mensaje service -->
      <p-toast></p-toast>
    </div>
  </form>
</p-dialog>

